/**
 * The colors the Customizer offers as shortcuts. The first one is always the
 * primary color from `src/configs/theme.ts` — and it is only used when
 * `userCustomizable` is enabled.
 */

// Palette Imports
import { lighten, darken, mainColor } from '@core/theme/palette'

// Config Imports
import theme from './theme'

export type PrimaryColorConfig = {
  name?: string
  light?: string
  main: string
  dark?: string
}

// Primary color config object
const primaryColorConfig: PrimaryColorConfig[] = [
  {
    name: 'primary-1',
    light: lighten(mainColor(theme.colors.primary), 0.2),
    main: mainColor(theme.colors.primary),
    dark: darken(mainColor(theme.colors.primary), 0.1)
  },
  {
    name: 'primary-2',
    light: '#4EB0B1',
    main: '#0D9394',
    dark: '#096B6C'
  },
  {
    name: 'primary-3',
    light: '#FFC25A',
    main: '#FFAB1D',
    dark: '#BA7D15'
  },
  {
    name: 'primary-4',
    light: '#F0718D',
    main: '#EB3D63',
    dark: '#AC2D48'
  },
  {
    name: 'primary-5',
    light: '#5CAFF1',
    main: '#2092EC',
    dark: '#176BAC'
  }
]

export default primaryColorConfig
